(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /*
   * =========================================================
   * DAILY CART - COLLECTION PRODUCT TITLE LIMIT
   * Maximum 10 words
   * =========================================================
   */

  function dailycartLimitProductTitles(root) {

    const scope = root || document;

    const titleSelectors = [
      '.product-card__title',
      '.product-card__heading',
      '.product-card-title',
      '[class*="product-card"] [class*="title"]',
      '[class*="product-card"] [class*="heading"]'
    ];

    const titleElements = [];

    titleSelectors.forEach((selector) => {

      scope.querySelectorAll(selector).forEach((element) => {

        if (!titleElements.includes(element)) {
          titleElements.push(element);
        }

      });

    });


    titleElements.forEach((element) => {

      if (element.dataset.dailycartTitleProcessed === 'true') {
        return;
      }

      const originalText = element.textContent
        .replace(/\s+/g, ' ')
        .trim();

      if (!originalText) {
        return;
      }


      const words = originalText.split(' ');


      if (words.length > 10) {

        const shortenedTitle =
          words.slice(0, 10).join(' ') + '...';

        element.textContent = shortenedTitle;

      }


      element.dataset.dailycartTitleProcessed = 'true';

    });

  }


  /*
   * Initial load
   */

  document.addEventListener(
    'DOMContentLoaded',
    () => {

      dailycartLimitProductTitles(document);

    },
    { once: true }
  );


  /*
   * Shopify / Horizon section reload
   */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      dailycartLimitProductTitles(event.target);

    }
  );


  /*
   * Infinite scroll / dynamically loaded products
   */

  const dailycartTitleObserver =
    new MutationObserver((mutations) => {

      let shouldRun = false;

      mutations.forEach((mutation) => {

        if (
          mutation.addedNodes &&
          mutation.addedNodes.length
        ) {
          shouldRun = true;
        }

      });


      if (shouldRun) {

        dailycartLimitProductTitles(document);

      }

    });


  dailycartTitleObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

  } catch(e) { console.error(e); }
})();
})();
